import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { CircularProgress, FormControl, FormLabel } from '@mui/material';
import { t } from 'i18next';
import { autoCompleteSxProps } from './BakeasyAutoComplete';
import { useState, FormEvent, Fragment, useEffect } from 'react';

const filter = createFilterOptions<any>();

interface BakeasySelectAutoCompleteProps {
  key?: any;
  inputValue?: string;
  options?: {}[];
  value?: string;
  multiple?: boolean;
  values?: string[] | undefined;
  label?: string;
  disabled?: boolean;
  onChange: (newValue: any) => void;
}

export function BakeasySelectAutoCompleteCategory(
  props: BakeasySelectAutoCompleteProps
) {
  const [value, setValue] = useState<any | null>(null);
  const [open, toggleOpen] = useState(false);

  const handleClose = () => {
    setDialogValue({
      title: '',
      year: '',
    });
    toggleOpen(false);
  };

  const [dialogValue, setDialogValue] = useState({
    title: '',
    year: '',
  });

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setValue({
      title: dialogValue.title,
      year: parseInt(dialogValue.year, 10),
    });
    handleClose();
  };

  return (
    <Fragment>
      <Autocomplete
        disabled={props?.disabled ?? false}
        value={value}
        onInputChange={(event: any, value: any) => {
          if (typeof value === 'string' && value?.length > 2) {
            props?.onChange(value);
          }
        }}
        onChange={(event, newValue) => {
          props?.onChange(newValue);
          if (typeof newValue === 'string') {
          } else if (newValue && newValue.inputValue) {
          }
        }}
        filterOptions={(options, params) => {
          const filtered = filter(options, params);

          if (params.inputValue !== '') {
            filtered.push({
              inputValue: params.inputValue,
              categoryName: `Add "${params.inputValue}"`,
            });
          }

          return filtered;
        }}
        id="free-solo-dialog-demo"
        options={props?.options ?? []}
        getOptionLabel={(option: any) => {
          if (typeof option === 'string') {
            return option;
          }

          if (option.categoryName) {
            return option.categoryName;
          }

          if (option.inputValue) {
            return option.inputValue;
          }

          return option;
        }}
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        renderOption={(props, option) => (
          <li {...props}>{option.categoryName}</li>
        )}
        sx={{ width: 300 }}
        freeSolo
        renderInput={(params) => (
          <TextField {...params} label="Free solo dialog" />
        )}
      />
      <Dialog open={open} onClose={handleClose}>
        <form onSubmit={handleSubmit}>
          <DialogTitle>Add a new film</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Did you miss any film in our list? Please, add it!
            </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              id="name"
              value={dialogValue.title}
              onChange={(event) =>
                setDialogValue({
                  ...dialogValue,
                  title: event.target.value,
                })
              }
              label="title"
              type="text"
              variant="standard"
            />
            <TextField
              margin="dense"
              id="name"
              value={dialogValue.year}
              onChange={(event) =>
                setDialogValue({
                  ...dialogValue,
                  year: event.target.value,
                })
              }
              label="year"
              type="number"
              variant="standard"
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button type="submit">Add</Button>
          </DialogActions>
        </form>
      </Dialog>
    </Fragment>
  );
}

function sleep(duration: number): Promise<void> {
  return new Promise<void>((resolve) => {
    setTimeout(() => {
      resolve();
    }, duration);
  });
}

export function BakeasySelectAutoCompleteCategoryA(
  props: BakeasySelectAutoCompleteProps
) {
  const [a, setA] = useState<any>(undefined);
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState<any>(props?.options);
  const loading = open && options.length === 0;

  useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      await sleep(1e3);

      if (active) {
        setOptions(props?.options);
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  useEffect(() => {
    if (props?.options && props?.options?.length > 0) {
      setOptions(props?.options);
    }
  }, [props?.options]);

  return (
    <Fragment>
      <FormControl sx={{ minWidth: 120 }} fullWidth={true}>
        <FormLabel sx={{ fontWeight: 600, fontSize: 15, marginBottom: 0.5 }}>
          {props?.label ? t(props.label) : t('CATEGORY')}
          {' *'}
        </FormLabel>
        <Autocomplete
          size="small"
          value={props.value || null}
          disabled={props?.disabled ?? false}
          sx={autoCompleteSxProps}
          id="asynchronous-demo"
          open={open}
          onOpen={() => {
            setOpen(true);
          }}
          onClose={() => {
            setOpen(false);
          }}
          isOptionEqualToValue={(option: any, value: any) => {
            return option?.categoryName === value?.categoryName;
          }}
          getOptionLabel={(option: any) => {
            return option?.categoryName;
          }}
          options={options}
          loading={loading}
          renderInput={(params: any) => {
            return (
              <TextField
                {...params}
                placeholder={t('SELECT_CATEGORY')}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <Fragment>
                      {loading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </Fragment>
                  ),
                }}
              />
            );
            //}
          }}
          onInputChange={(event: any, value: any) => {
            if (typeof value === 'string' && value?.length > 2) {
              props?.onChange(value);
            }
          }}
          onChange={(event, newValue) => {
            if (typeof newValue === 'object') {
              props?.onChange(newValue);
            }
          }}
        />
      </FormControl>
    </Fragment>
  );
}

export function BakeasySelectAutoCompleteSubCategory(
  props: BakeasySelectAutoCompleteProps
) {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState<any>(props?.options);
  const loading = open && options.length === 0;

  useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      await sleep(1e3);
      if (active) {
        setOptions(props?.options);
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  useEffect(() => {
    if (props?.options && props?.options?.length > 0) {
      setOptions(props?.options);
    }
  }, [props?.options]);

  return (
    <FormControl sx={{ minWidth: 120 }} fullWidth={true} disabled={false}>
      <FormLabel sx={{ fontWeight: 600, fontSize: 15, marginBottom: 0.5 }}>
        {props?.label ? t(props.label) : t('SUBCATEGORY')}
        {' *'}
      </FormLabel>
      <Autocomplete
        size="small"
        value={props.value || null}
        disabled={props?.disabled ?? false}
        sx={autoCompleteSxProps}
        id="asynchronous-demo"
        open={open}
        onOpen={() => {
          setOpen(true);
        }}
        onClose={() => {
          setOpen(false);
        }}
        isOptionEqualToValue={(option: any, value: any) => {
          return option?.subCategoryName === value?.subCategoryName;
        }}
        getOptionLabel={(option: any) => {
          return option?.subCategoryName;
        }}
        options={options}
        loading={loading}
        renderInput={(params) => {
          return (
            <TextField
              {...params}
              placeholder={t('SELECT') + t('SUB_CATEGORY')}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <Fragment>
                    {loading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </Fragment>
                ),
              }}
            />
          );
        }}
        onInputChange={(event: any, value: any) => {
          if (typeof value === 'string' && value?.length > 2) {
            props?.onChange(value);
          }
        }}
        onChange={(event, newValue) => {
          if (typeof newValue === 'object') {
            props?.onChange(newValue);
          }
        }}
      />
    </FormControl>
  );
}

export function BakeasySelectAutoCompleteMessageFrom(
  props: BakeasySelectAutoCompleteProps
) {
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState<any>(props?.options);
  const loading = open && options?.length === 0;

  useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      await sleep(1e3);

      if (active) {
        setOptions(props?.options);
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  useEffect(() => {
    if (props?.options && props?.options?.length > 0) {
      setOptions(props?.options);
    }
  }, [props?.options]);

  return (
    <Fragment>
      <FormControl sx={{ minWidth: 120 }} fullWidth={true}>
        <FormLabel sx={{ fontWeight: 600, fontSize: 15, marginBottom: 0.5 }}>
          {props?.label ? t(props?.label) : t('FROM')}
          {/* {' *'} */}
        </FormLabel>
        <Autocomplete
          multiple={props?.multiple ?? false}
          size="small"
          value={props?.multiple ? props?.values : props?.value}
          disabled={props?.disabled ?? false}
          sx={autoCompleteSxProps}
          id="asynchronous-demo"
          open={open}
          onOpen={() => {
            setOpen(true);
          }}
          onClose={() => {
            setOpen(false);
          }}
          isOptionEqualToValue={(option: any, value: any) => {
            if (typeof option === 'string') {
              return true;
            }
            return option?.name === value?.name;
          }}
          getOptionLabel={(option: any) => {
            if (typeof option === 'string') {
              return option;
            }
            return option?.name;
          }}
          options={options}
          loading={loading}
          renderInput={(params: any) => {
            return (
              <TextField
                {...params}
                placeholder={t('SELECT_FROM')}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <Fragment>
                      {loading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </Fragment>
                  ),
                }}
              />
            );
            //}
          }}
          onInputChange={(event: any, value: any) => {
            if (
              typeof value === 'string' &&
              (value?.length > 2 || value?.length === 0)
            ) {
              props?.onChange(value);
            }
          }}
          onChange={(event, newValue) => {
            if (typeof newValue === 'object') {
              props?.onChange(newValue);
            }
          }}
        />
      </FormControl>
    </Fragment>
  );
}

export function BakeasySelectAutoCompleteMessageTo(
  props: BakeasySelectAutoCompleteProps
) {
  const [a, setA] = useState<any>(undefined);
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState<any>(props?.options);
  const loading = open && options?.length === 0;

  useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      await sleep(1e3);

      if (active) {
        setOptions(props?.options);
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  useEffect(() => {
    if (props?.options && props?.options?.length > 0) {
      setOptions(props?.options);
    }
  }, [props?.options]);

  return (
    <Fragment>
      <FormControl sx={{ minWidth: 120 }} fullWidth={true}>
        <FormLabel sx={{ fontWeight: 600, fontSize: 15, marginBottom: 0.5 }}>
          {props?.label ? t(props?.label) : t('TO')}
          {/* {' *'} */}
        </FormLabel>
        <Autocomplete
          multiple={props?.multiple ?? false}
          size="small"
          value={props?.multiple ? props?.values : props?.value}
          disabled={props?.disabled ?? false}
          sx={autoCompleteSxProps}
          id="asynchronous-demo"
          open={open}
          onOpen={() => {
            setOpen(true);
          }}
          onClose={() => {
            setOpen(false);
          }}
          isOptionEqualToValue={(option: any, value: any) => {
            if (typeof option === 'string') {
              return true;
            }
            return option?.supplierName === value?.name;
          }}
          getOptionLabel={(option: any) => {
            if (typeof option === 'string') {
              return option;
            }
            return option?.name;
          }}
          options={options}
          loading={loading}
          renderInput={(params: any) => {
            return (
              <TextField
                {...params}
                placeholder={t('SELECT_TO')}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <Fragment>
                      {loading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </Fragment>
                  ),
                }}
              />
            );
          }}
          onInputChange={(event: any, value: any) => {
            if (
              typeof value === 'string' &&
              (value?.length > 2 || value?.length === 0)
            ) {
              props?.onChange(value);
            }
          }}
          onChange={(event, newValue) => {
            if (typeof newValue === 'object') {
              props?.onChange(newValue);
            }
          }}
        />
      </FormControl>
    </Fragment>
  );
}
